import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/student-dashboard.css';
import PopupBox from './PopupBox';
import { createBangaloreGatepass, getStudentStatus } from '../api/api';

const Icons = {
    arrowLeft: <svg className="sa-icon-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>,
    building: <svg className="sa-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18"></path><path d="M5 21V7l7-4 7 4v14"></path></svg>,
};

const BangaloreGatepass = () => {
    const navigate = useNavigate();

    const getIndiaNow = () => new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
    const formatDateInput = (date) => {
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const minExitDate = formatDateInput(getIndiaNow());

    const [profile, setProfile] = useState({
        studentName: '',
        rollnumber: '',
        roomNumber: '',
        hostelName: '',
        course: '',
        department: '',
        branch: '',
        contact: '',
    });

    const [form, setForm] = useState({
        dateOut: '',
        timeOut: '',
    });

    const [loading, setLoading] = useState(false);
    const [popup, setPopup] = useState({ open: false, message: '' });
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [, setProfileLoading] = useState(true);

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const res = await getStudentStatus();
                const { studentName, rollnumber, department, branch, course, roomNumber, contactNumber, hostelName } = res.data;
                setProfile({
                    studentName: studentName || '',
                    rollnumber: rollnumber || '',
                    roomNumber: roomNumber || '',
                    hostelName: hostelName || '',
                    course: course || '',
                    department: department || '',
                    branch: branch || '',
                    contact: contactNumber || '',
                });
            } catch (error) {
                console.error('Failed to fetch profile:', error);
            } finally {
                setProfileLoading(false);
            }
        };
        fetchProfile();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (loading) return;

        const { dateOut, timeOut } = form;

        if (!dateOut) {
            setPopup({ open: true, message: 'Missing: Exit Date' });
            return;
        }
        if (!timeOut) {
            setPopup({ open: true, message: 'Missing: Exit Time' });
            return;
        }

        const outDateTime = new Date(`${dateOut}T${timeOut}`);
        if (outDateTime <= getIndiaNow()) {
            setPopup({ open: true, message: 'Out time must be in the future.' });
            return;
        }

        setLoading(true);
        createBangaloreGatepass({
            ...profile,
            dateOut,
            timeOut,
            consent: true,
        })
            .then(() => {
                setSubmitSuccess(true);
                setPopup({ open: true, message: 'Bangalore gatepass submitted. The Hostel Office will review your request.' });
            })
            .catch((err) => {
                const message = err?.response?.data?.message || 'Failed to submit gatepass.';
                setPopup({ open: true, message });
            })
            .finally(() => setLoading(false));
    };

    return (
        <div className="sd-shell">
            <header className="sd-header">
                <div className="sd-header-brand">
                    <span className="sd-logo">GoThru</span>
                </div>
                <button className="sa-back-btn" onClick={() => navigate('/student/gatepass')}>
                    {Icons.arrowLeft} Back
                </button>
            </header>

            <main className="sd-main lg-main">
                <h1 className="lg-title">Bangalore Campus Transfer</h1>
                <div style={{ textAlign: 'center', marginBottom: '16px', color: '#c0392b', fontSize: '14px', fontWeight: 500 }}>
                    Only for 3rd year students moving permanently to Bangalore campus RGIPT.
                </div>

                <form className="lg-form" onSubmit={handleSubmit}>
                    <div className="lg-section">
                        <div className="lg-section-label">STUDENT INFORMATION</div>
                        <div className="lg-info-grid">
                            <div className="lg-info-item">
                                <span className="lg-info-label">Name</span>
                                <span className="lg-info-value">{profile.studentName || '—'}</span>
                            </div>
                            <div className="lg-info-item">
                                <span className="lg-info-label">Roll No.</span>
                                <span className="lg-info-value">{profile.rollnumber || '—'}</span>
                            </div>
                            <div className="lg-info-item">
                                <span className="lg-info-label">Department</span>
                                <span className="lg-info-value">{profile.department || '—'}</span>
                            </div>
                            <div className="lg-info-item">
                                <span className="lg-info-label">Room No.</span>
                                <span className="lg-info-value">{profile.roomNumber || '—'}</span>
                            </div>
                            <div className="lg-info-item">
                                <span className="lg-info-label">Hostel</span>
                                <span className="lg-info-value">{profile.hostelName || '—'}</span>
                            </div>
                            <div className="lg-info-item">
                                <span className="lg-info-label">Contact</span>
                                <span className="lg-info-value">{profile.contact || '—'}</span>
                            </div>
                        </div>
                    </div>

                    <div className="lg-section">
                        <div className="lg-section-label">TRAVEL DETAILS</div>
                        <div className="lg-row">
                            <div className="lg-field">
                                <label className="lg-label">Exit Date</label>
                                <input
                                    className="lg-input"
                                    type="date"
                                    name="dateOut"
                                    min={minExitDate}
                                    value={form.dateOut}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="lg-field">
                                <label className="lg-label">Exit Time</label>
                                <input
                                    className="lg-input"
                                    type="time"
                                    name="timeOut"
                                    value={form.timeOut}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <button type="submit" className="lg-submit-btn" disabled={loading}>
                        {loading ? 'Submitting...' : <>{Icons.building} Submit Application</>}
                    </button>
                </form>
            </main>

            <div className="sd-footer">
                GoThru v1.1 • RGIPT Campus Access System
            </div>

            <PopupBox
                isOpen={popup.open}
                message={popup.message}
                onClose={() => {
                    setPopup({ open: false, message: '' });
                    if (submitSuccess) {
                        navigate('/student');
                    }
                }}
            />
        </div>
    );
};

export default BangaloreGatepass;
